import React from "react";
import { Link } from "react-router-dom";

// ==========================================
// COMPONENTE BUTTON REUTILIZÁVEL
// ==========================================

const Button = ({
  children,
  variant = "primary",
  className = "",
  onClick,
  to,
  style: customStyle = {},
  type = "submit", // padrão submit para funcionar em formulários
}) => {
  const baseStyle = {
    padding: "0.75rem 1.5rem",
    borderRadius: "8px",
    fontWeight: 600,
    textDecoration: "none",
    transition: "all 0.3s",
    cursor: "pointer",
    border: "none",
    fontSize: "0.95rem",
    display: "inline-flex",
    alignItems: "center",
    gap: "0.5rem",
  };

  const variants = {
    primary: {
      background: "linear-gradient(135deg, var(--primary), var(--accent))",
      color: "white",
      boxShadow: "0 4px 15px rgba(37, 99, 235, 0.3)",
    },
    secondary: {
      background: "var(--card-bg)",        // 🔁
      color: "var(--text-primary)",        // fica legível nos dois temas
      border: "1px solid var(--border-color)",
    },
    outline: {
      background: "transparent",
      color: "white",
      border: "2px solid white",          // aqui ok ser branco, é detalhe
    },
  };

  // mantém a mesma formatação, mas permite style extra vindo de fora
  const style = {
    ...baseStyle,
    ...(variants[variant] || variants.primary),
    ...customStyle,
  };

  if (to) {
    return (
      <Link
        to={to}
        style={style}
        className={className}
        onClick={onClick}
      >
        {children}
      </Link>
    );
  }

  return (
    <button
      type={type}
      onClick={onClick}
      style={style}
      className={className}
    >
      {children}
    </button>
  );
};

export default Button;